import { apiClient } from '@/provider';
import geotagsSchema from './geotag-list.graphql';

export default {
  async fetch() {
    const res = await apiClient.query({
      query: geotagsSchema.load,
      fetchPolicy: 'no-cache'
    });
    return res.data?.objects;
  }
};
